var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1WindowOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 53V18H21v35h-6v4h7.4L52 67V57h9v-4h-5zM25 23.61l9 3v12.9l-9-3v-12.9zM38 28l10 3.36v12.85l-10-3.35V28zM25 40.72l9 3v12.96l-9-3V40.72zm23 20.67L38 58V45l10 3.36v13.03z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Window_open.9ce46624.svg";
export { SvgC1WindowOpen as ReactComponent };